import reducers from './reducers';

export const NAME = 'reportExplore';

export default reducers;
